import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import {
    forwardRef,
    ReactElement,
    RefObject,
    useEffect,
    useState,
} from "react";
import { useIsSM } from "@/hooks/useWindowSizes";
import { TourReadableTO } from "@/models/detail";
import styles from "@/styles/detail/DetailBooking.module.scss";
import useOnScreen from "@/hooks/useOnScreen";
import { useStore } from "@/store/index";
import { EDetailSection, ETypePackage } from "@/models/common/enums";
import PackageDetailBookingMobile from "@/components/detail/DetailBooking/PackageDetailBookingMobile";
import Sidebar from "./DetailBookingSidebar/Sidebar";
import PackageDetailDescription from "../PackageDetailDescription";
import TravelExperienceSectionDetail from "./DetailBookingSidebar/TravelExperienceSectionDetail";
import { RequestAQuoteForm } from "./RequestAQuoteForm";

const PackageDetailBooking = forwardRef<
    HTMLDivElement,
    {
        packageDetail: TourReadableTO;
        isRequestAQuote: boolean;
        isPremium: boolean;
        setIsPremium: (el: boolean) => void;
        // setIsPromo: (el: boolean) => void;
        days: string;
        typePackage: ETypePackage;
        pricePremium: number;
        priceQuality: number;
        packagePremium: TourReadableTO;
        packageQuality: TourReadableTO;
    }
>(
    (
        {
            packageDetail,
            isRequestAQuote,
            isPremium,
            setIsPremium,
            // setIsPromo,
            days,
            typePackage,
            pricePremium,
            priceQuality,
            packagePremium,
            packageQuality,
        },
        ref
    ): ReactElement => {
        const isSM = useIsSM();

        // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
        const [price, setPrice] = useState<number>(+packageDetail.price);

        const dispatch = useStore(state => state.dispatchPackage);

        const isOnScreen = useOnScreen(ref as RefObject<HTMLElement>);

        useEffect(() => {
            if (isOnScreen) {
                dispatch({
                    type: "SET_CURRENT_SECTION",
                    payload: EDetailSection.GENERAL,
                });
            }
        }, [isOnScreen]);

        return (
            <div ref={!isSM ? ref : null} className={styles.customContainer}>
                <MDBContainer fluid className={styles.containerSpacer}>
                    <MDBRow>
                        <MDBCol
                            ref={isSM ? ref : null}
                            size={12}
                            lg={7}
                            className="p-0 pe-lg-4 "
                        >
                            <PackageDetailDescription
                                packageDetail={packageDetail}
                                gallery={packageDetail.gallery}
                                whatIsIncluded={packageDetail.whatIsIncluded}
                                whatIsIncludedDelta={
                                    packageDetail.whatIsIncludedDelta
                                }
                            />
                            <TravelExperienceSectionDetail />
                        </MDBCol>
                        {isSM && (
                            <PackageDetailBookingMobile
                                days={days}
                                isOnScreen={isOnScreen}
                                isPremium={isPremium}
                                offset={
                                    (ref as RefObject<HTMLElement>).current
                                        ?.offsetTop ?? 1155
                                }
                                packageDetail={packageDetail}
                                setIsPremium={setIsPremium}
                                // setIsPromo={setIsPromo}
                                typePackage={typePackage}
                                price={price}
                                // setPrice={setPrice}
                                pricePremium={pricePremium}
                                priceQuality={priceQuality}
                                packagePremium={packagePremium}
                                packageQuality={packageQuality}
                                languages={packageDetail.languages}
                                isRequestAQuote={isRequestAQuote}
                            />
                        )}

                        {!isSM && isRequestAQuote && (
                            <MDBCol
                                size={12}
                                lg={5}
                                className={`p-0 ps-lg-4 ${styles.addToCartContainer}`}
                            >
                                <RequestAQuoteForm
                                    id={packageDetail.tourId}
                                    title={packageDetail.tourTitle}
                                    activities={
                                        packageDetail.requestAQuoteActivities ??
                                        []
                                    }
                                />
                            </MDBCol>
                        )}

                        {!isSM && !isRequestAQuote && (
                            <MDBCol
                                size={12}
                                lg={5}
                                className={`p-0 ps-lg-4 ${styles.addToCartContainer}`}
                            >
                                <Sidebar
                                    tourId={packageDetail.tourId}
                                    isPremium={isPremium}
                                    setIsPremium={setIsPremium}
                                    slots={packageDetail.slots}
                                    slotsPremium={packagePremium.slots}
                                    slotsQuality={packageQuality.slots}
                                    days={days}
                                    typePackage={typePackage}
                                    pricePremium={pricePremium}
                                    priceQuality={priceQuality}
                                    languages={packageDetail.languages}
                                />
                            </MDBCol>
                        )}
                    </MDBRow>
                </MDBContainer>
            </div>
        );
    }
);

export default PackageDetailBooking;
